import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "./data";

export default function Testimonials() {
  return (
    <section id="reviews" data-testid="testimonials-section" className="scroll-mt-20 bg-[#F9F3EA] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#E86A24]">Guest Reviews</p>
          <h2 className="mt-3 font-display text-2xl font-semibold tracking-tight text-[#3A2C1E] sm:text-3xl lg:text-4xl">
            Loved by Chapel Hill Locals
          </h2>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`testimonial-card-${i}`}
              className="card-glow flex flex-col rounded-2xl border border-[#C97B5F]/15 bg-white p-6 shadow-[0_16px_50px_rgba(0,0,0,0.45)]"
            >
              <Quote size={22} className="text-[#E86A24]/60" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-stone-600">"{t.text}"</blockquote>
              <figcaption className="mt-5 border-t border-[#C97B5F]/10 pt-4">
                <div className="flex gap-0.5" aria-label={`${t.rating} star review`}>
                  {Array.from({ length: t.rating }).map((_, s) => (
                    <Star key={s} size={13} className="fill-[#E86A24] text-[#8A3324]" />
                  ))}
                </div>
                <p className="mt-2 text-sm font-bold text-[#3A2C1E]">{t.name}</p>
                <p className="text-xs text-stone-500">{t.suburb}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
